<div class="l-main" role="main">
	<div class="l-container">

		<div class="l-content">


			<div class="panel-pane bg-transparent align-center">
				<ul class="list--pipe">
					<li><a href="">Visit the UC Davis directory</a></li>
				</ul>
			</div>

			<div class="panel-pane box">
				<!-- ********** Main content ********** -->

	<div id="listings">
		<h1>Approver Help</h1>
		<hr />
			
			
			<a name="definitions"></a>
			
			<br/>
			<h2>Roles and Definitions</h2>
			<br/><br/>
			
			<strong>PPS Department</strong><br/>
			Department or unit name as it exists in the Payroll/Personnel System. The PPS department is considered authoritative over the listing units.
			<br/><br/>
			
			<strong>Super Approver</strong><br/>
			Designated at the PPS department level, super approvers are authorized to approve listings for all individuals within their assigned PPS departments. They can add and remove other super approvers for their assigned PPS departments, but must maintain at least one super approver at all times.  They can also add and remove unit approvers for all listing units that exist for their PPS department.
			<br/><br/>
			
			<strong>Unit Approver</strong><br/>
			Designated by the super approver, unit approvers are authorized to approve listings for a listing unit of their PPS department. Unit approvers are also able to add and delete other unit approvers for their listing unit, but should only do so with the concurrence of the super approver.
			<br/><br/>
			
			
			<a name="DepartmentApprover"></a>
			
			<strong>Department Approver - NEW!</strong><br/>
			<strong>Only super approvers can become department approvers.</strong> Department approvers are responsible for updating their assigned department listings. Department updates can be made at any time during the year. See the help section on <a href="#department" title="Department Update Instructions">Updating Department Listings</a>.
			<br/><br/>
			
			<strong>Individual Listing</strong><br/>
			An individual listing is rooted in a person's PPS record. When a new person is hired by the university, their new PPS record triggers the creation of a basic individual listing - the person's name, payroll title and PPS department. This individual, or the super approver for their PPS department, can log in and modify the individual listing. <a routerLink="/guidelines">Publishing guidelines</a> and recommendations regarding appropriate content for individual listings are available in the help menu.
			<br/><br/>
			
			<strong>Department Listing</strong><br/>
			A department listing is an organized presentation of contact information, sub-unit organization, and other pertinent information related to a campus department. <a routerLink="/guidelines">Publishing guidelines</a> and recommendations regarding appropriate content for department listings are available in the help menu.
			<br/><br/>
			
			<strong>Department Listing Cross-Reference</strong><br/>
			Often called a keyword or search term, a department listing cross-reference is a word or group of words that the general public associates with your department listing. For example, the term "Phone" would most appropriately be associated with the telecommunications services provided on campus by IET - Communications Resources. Thus, the term "Phone" is listed as a department cross-reference for IET - Communications Resources. In the online department search, the results for a search for "Phone" would appear as "Phone, See: IET - Communications Resources".
			<br/><br/>
			
			<strong>Listing Unit</strong><br/>
			A listing unit is a department or unit name as it is listed in the directory. Listing units are paired with PPS departments to make unique listing combinations for which unit approvers can be designated. While there is often only one listing unit associated with a PPS department, it is also common for there to be several listing units associated with a PPS department. For example, there could be a listing unit with the same name as the PPS department plus a named institute, which would create two unique listing pairs associated with a single PPS department.
			<br/><br/>
			
			<strong>Quality Assurance (QA) Approver </strong><br/>
			The quality assurance (QA) team conducts the final review of all directory information approved by approvers. QA is divided into two groups:
			<br/>
			<ul>
				<li>UC Davis Campus QA in Communications Resources</li>
				<li>UC Davis Health System QA in Telecommunications</li>
			</ul>			
			The QA group you are assigned to depends upon your PPS department. Only UC Davis Medical Center, Hospitals and Clinics and the School of Medicine are assigned to the UC Davis Health System QA.
			<br/><br/>
			
			<strong>Display Name</strong><br/>
			Display name refers to the name that is published in the search results of the online directory. This is not the same as an individual's "Official Name", see "Official Name" definition below. Changing an employee's "Display Name" only changes their name that is published in the online directory.
			<br/><br/>
			
			<strong>Official Name</strong><br/>
			<br/><br/>			
			
			<a name="accessing"></a>
			
			<br/>
			<h2>Accessing the Online Directory Listings Application</h2>
			<br/><br/>
			
			To access the Online Directory Listings Application:<br/>
			<ol>
				<li>Click on "Log In Now!"</li>
				<li>Enter your UC Davis login ID and Kerberos passphrase when prompted.</li>
			</ol>
			<br/><br/>
			
			<a name="reviewing"></a>
			
			<br/>
			<h2>Pending Requests</h2>
			<br/><br/>
			
			<ol>
				<li>After an employee listing has been revised, the changes made will be displayed on your <em>Pending Requests</em> page. </li>
				<li>You may take one of these actions in the employee approval screen:<br/><br/></li>
				<ul>
					<strong>Approve Updates:</strong> Accept the listing change and route it to the directory services quality assurance team (QA)<br/>
					<strong>Deny Updates:</strong> Reject the listing changes and notify the requester.<br/>
					<strong>Edit Updates:</strong> Make additional edits and then approve and send the request to QA.<br/>
				</ul>
				<li>Select <em>Submit Request</em> to confirm the changes.</li>
				<li>Once you have verified your changes, return to the <em>Pending Requests</em> page.  Pending requests will be displayed on this page as Pending QA status.  No further action is required.</li>
			</ol>
			<em>Note: If an address is entered, the city, state and ZIP code fields auto fill with Davis, CA 95616 when left blank. If a five-digit phone number is entered, the 530 area code and 75 prefix will auto fill when submitted.</em>
			<br/><br/>
			
			<a name="reminder_email"></a>
			
			<br/>
			<h2>Notifications and Reminders</h2>
			<br/><br/>
			
			You will receive a reminder e-mail if an individual update request is pending for more than 24 hours. You will also receive a notification if there are any changes in the approver roles - i.e., if any super or unit approvers are added or removed from your PPS departments and listing units.<br/><br/>
			
			<br/>
			<h2>Status Definitions</h2>
			<br/><br/>
			
			<ul>
				<strong>"Pending Dept Approval":</strong> The listing is waiting for departmental approval. The employee may open a listing request that is in this state and make additional edits.<br/>
				<strong>"Pending Dept Approval - Previously viewed by <span style="font-style: italic">Approver Name</span>":</strong> The listing has been opened by another approver. You may want to check with the approver who has viewed the change request to ensure that they are not already investigating it with the intention of approving it.  Only the approvers will have access to this listing until they approve the changes.<br/>
				<strong>"Pending QA":</strong> The listing is waiting for the directory services QA team to approve it.  Employees and approvers may open a listing in this state.<br/>
				<strong>"Pending QA - Locked for Edits":</strong> The directory services QA team has opened the record for review and approval.  Neither individuals nor approvers will have access to this listing while it is being reviewed.<br/>
			</ul>
			<br/><br/>
			
			<a name="single"></a>
			
			<br/>
			<h2>Updating Individual Listings</h2>
			<br/><br/>
			
			
			<ol>
				<li>From the <em>Individual Updates</em> page, select the department that contains the individual listings you would like to edit.</li>
				<li>Choose an employee's listing and select <em>Update Listing</em>. </li>
				<li>Edit the fields as needed, or if the person has multiple appointments, add additional listings by clicking <em>Add Listing</em> and entering data in the applicable fields.</li>
				<li>Click <em>Submit Request</em> when you are finished editing.</li>
				<li>Use the <em>View Next Listing</em> button to move directly to the next alphabetically consecutive listing. Or, use the <em>Return to Individual Updates </em>button to return to the list of individuals. </li>
			</ol>
			
			<a name="email_default"></a>
			
			<em>Note: Your UC Davis e-mail address will automatically appear in your listings e-mail address drop-down. If you would like to publish a different e-mail address, you may select --Enter Other E-mail-- in the drop-down. Enter your alternate e-mail in the resulting text box.</em><br/><br/>
			
			<em>Note: If an address is entered, the city, state and ZIP code fields auto fill with Davis, CA 95616 when left blank. If a five-digit phone number is entered, the 530 area code and 75 prefix will auto fill when submitted.</em><br/><br/>
			
			<br/>
			
			<a name="listingunits"></a>
			
			<br/>
			<h2>Adding or Changing Listing Units in the Department Drop-down</h2>
			<br/><br/>
			
			If you would like to change the name of a listing unit or add a new listing unit, please e-mail the following information to <a href="mailto:campusdirectory@ucdavis.edu">campusdirectory@ucdavis.edu</a>.<br/>
			<ul>
				<li>Your name and employee ID number (for approver verification)</li>
				<li>Current listing unit name (exclude if adding a new listing unit)</li>
				<li>Desired listing unit name</li>
			</ul>
			<br/><br/>
			
			<a name="department"></a>
			
			<br/>
			<h2>Updating Department Listings</h2>
			<br/><br/>
			
			You can only update department listings for which you are the authorized department approver. To update a department listing, or to add a new listing, please follow the steps below.<br/>
			
			<ol>
				<li>Log in with your UC Davis login ID and Kerberos passphrase</li>
				<li>Select the <em>Reports</em> tab on the right of the top menu</li>
				<li>Select <em>Preview Department Listings</em>
					<ul>
						<li>A list of department names should appear. You are a department approver for these department listings.</li>
						<li>Please make sure your list is complete. If you see departments that should not be assigned to you, or if a department is missing, contact <a href="mailto:campusdirectory@ucdavis.edu">campusdirectory@ucdavis.edu</a>.</li>
					</ul>
				</li>
				<li>Select <em>View My Department Listings</em>
					<ul>
						<li>A new window will open to display a multi-page PDF of your department proofing packet. The packet contains a cover page with a signature section and instructions, and each department listing should follow on separate pages. </li>
					</ul>
				</li>
				<li>Print the PDF, mark any changes in RED INK and follow the instructions on the first page of the PDF.</li>
				<ul>
					<li>If you wish to remove a department listing, please check the "Delete This Department Listing" box located at the top of the page.</li>
					<li>If you do not have changes, please check the "No Changes" box located at the top of the page.</li>
				</ul>
			</ol>
			<br/><br/>
			
			<a name="crossref"></a>
			
			<br/>
			<h2>Creating Department Listing Cross-References</h2>
			<br/><br/>
			
			As the department approver, you may create cross-references that will point the public toward your department contact information. "Phone" is an example of a cross-reference for IET - Communications Resources (the campus department that you would call if you want to order new phone service, etc.). If you would like to add cross-references for your department (so that the public can more readily locate your department listing in the online department search) please follow the steps below. 
			
			<ol>
				<li>Locate the department listing for which you would like to create a cross-reference in your department listings proof PDF.</li>
				<li>Write "Cross-reference: <strong><em>&lt;&lt;YOUR CROSS-REFERENCE TERM&gt;&gt;</em></strong>: See <em><strong>&lt;&lt;YOUR DEPARTMENT NAME&gt;&gt;</strong></em>" in RED INK below the referenced department listing.</li>
			</ol>
			<br/><br/>
			
			<a name="help"></a>
			
			<br/>
			<h2>Getting More Help</h2>
			<br/><br/>
			
			<table class="help" cellpadding="4" cellspacing="1" id="help" title="help">
				<tr>
					<th valign="top" align="left">If you are:</th>
					<th valign="top" align="left">Contact:</th>
				</tr>
				<tr>
					<td valign="middle" style="background-color:#FFFFFF">On the UC Davis campus:</td>
					<td valign="top" style="background-color:#FFFFFF">
						<strong>IT Express Computing Services Help Desk</strong><br/>
						Phone: 530-754-4357 (Mon-Fri, 7 a.m.-9 p.m.)<br/>
						E-mail: <a href="mailto:ithelp@ucdavis.edu">ithelp@ucdavis.edu</a>
					</td>
				</tr>
				<tr>
					<td valign="middle" style="background-color:#FFFFFF">Part of the UC Davis Health System:</td>
					<td valign="top" style="background-color:#FFFFFF">
						<strong>UC Davis Health System Telecommunications</strong><br/>
						<strong>Directory Resources</strong><br/>
						Phone: 916-734-8700 (option 4) (Mon-Fri, 7:30 a.m.-4:30 p.m.)
					</td>
				</tr>
			</table>
			<br/> <br/>
			
			<a name="deptapprovers"></a>
			
			<br/>
			<h2>Adding/Changing/Removing Department Approvers</h2>
			<br/><br/>
			
			<strong> You must be a super approver in order to become a department approver.</strong> At the beginning of the Online Department Directory project, department listings were assigned to super approvers automatically based on their PPS department assignments. If you would like to change the department approvers for your department, please send an e-mail to <a href="mailto:campusdirectory@ucdavis.edu">campusdirectory@ucdavis.edu</a> with the following information:<br/><br/>
			
			<ol>
				<li>Your name</li>
				<li>Your employee ID number</li>
				<li>The name(s) of the department listing(s) that you would like to be a department approver for</li>
				<li>Any other questions you have about department listings maintenance, online directory tools, etc.</li>
			</ol>
			<br/>
			If you are a department approver, you may use <em>Tools -> View Dept Approvers</em> to:
			<ul>
				<li>See your assigned department listings and their corresponding cross-references</li>
				<li>See the other approvers for your department listings</li>
			</ul>
			
			<a name="approvers"></a>
			
			<br/>
			<h2>Assigning the Super Approver and Unit Approver Roles</h2>
			<br/><br/>
			
			The <em>Assign Approvers</em> interface allows approvers like you to:
			<ul>
				<li>See your PPS departments and listing units</li>
				<li>See the other approvers for your PPS departments and listing units (click on the PPS department or listing unit to view all of the assigned approvers.)</li>
				<li>Add and remove approvers for your PPS departments and listing units</li>
			</ul>
			
			If you are a super approver for a PPS department(s), you may use <em>Tools -> View Emp Approvers</em> to:<br/>
			<ul>
				<li>Add or remove super approvers and unit approvers for your PPS department(s) and listing units.</li>
				<li>Remove yourself as an approver, <em>as long as another super approver is already assigned to your PPS department</em>.  <strong>You cannot delete yourself as a super approver if you are the only super approver for your PPS department. Someone else must first be designated as the new super approver before you remove yourself.</strong></li>
			</ul>
			<br/>
			
			If you are a unit approver, you may:<br/>
			<ul>
				<li>Add or delete additional approvers for any unit for which you have already been designated as an approver.</li>
				<li>Delete yourself as an approver, even if there is no other approver listed for that unit, as long as there is a super approver listed for the presiding PPS department.</li>
			</ul>
			<br/>
			<em>Note: A PPS department MUST have at least one super approver, but is not required to have unit approvers.  The ability to assign unit approver status enables the super approver to distribute responsibility for directory updates.</em>
			<br/><br/>
			
			<br/>
			<h2>Adding Super Approvers and Unit Approvers</h2>
			<br/><br/>
			
			<ol>
				<li>Click on <em>Tools</em> in the Main Menu, then click on <em>Assign Approvers</em> from the Tools sub-menu.</li>
				<li>Obtain the new approver's employee ID, either from the approver or from the PPS department's payroll specialist.</li>
				<li>Enter the new approver's employee ID in the box below the current approver list and click on the <em>Add New...</em> button.</li>
				<li>Review the new approver's contact information for accuracy.  The telephone number and e-mail address can be edited at this step.  A telephone number is optional, but an e-mail address is required.</li>
				<li>Click on the <em>Submit</em> button.</li>
				<li>The information you submitted will be displayed, and the new approver will get an e-mail notification.  Click on the "continue" link if you have more changes to make.  Additions are effective immediately.</li>
			</ol>
			
			<em>Note: A super approver can add other super approvers for the same PPS department, and unit approvers to any listing department under the PPS department.  Unit approvers can add additional approvers to listing departments for which they are a designated approver.</em><br/><br/>
			
			<br/>
			<h2>Removing Super Approvers and Unit Approvers</h2>
			<br/><br/>
			
			<ol>
				<li>Check the box below <em>Delete</em> for all of the approvers to be removed.</li>
				<br/>
				<em>Note: If you are the only super approver for a PPS department, you will not be able to delete yourself from the super approver list.  You must contact QA at <a href="mailto:campusdirectory@ucdavis.edu">campusdirectory@ucdavis.edu</a> and request removal.</em><br/><br/>
				<li>Click the <em>Delete</em> button at the top of the column. There is no confirmation step for deletion.</li>
				<li>The name you submitted will be displayed, and the former approver will get an e-mail notification.  Click on the <em>Continue</em> link if you have more changes to make. Deletions are effective immediately.</li>
			</ol>
			
			<em>Note: A super approver can delete other super approvers for the same PPS department, and unit approvers from any listing department under the PPS department.  Unit approvers can delete other approvers from listing departments for which they are a designated approver.</em>
			
			<br/><br/>
			
			<br/>
			<h2>Adding Yourself as an Approver</h2>
			<br/><br/>
			
			If you are a super approver, you can approve directory updates for any of the listing departments under your PPS department, whether or not there are unit approvers assigned.  However, you will not receive notifications for listing departments that have unit approvers.  If you wish to receive the e-mail notifications associated with such listing departments, you can add yourself to them as a unit approver.
			
			<ul>
				<li>If you should be the super approver for a PPS department and the existing super approver has left the university, contact QA at <a href="mailto:campusdirectory@ucdavis.edu">campusdirectory@ucdavis.edu</a>.</li>
				<li>Unit approvers cannot add themselves to listing departments.  It is primarily the super approver's responsibility to add unit approvers to listing departments.</li>
			</ul>
			<br/>
<!--			
			<a name="preview"></a>
			
			<br/>
			<h2>Previewing the Individual Listings Report</h2>
			<br/><br/>
			
			You can generate a PDF version of your individual listings as they will appear in the printed campus directory (you will see all listings that have a checked "DIR" publish setting).<br/>
			
			NOTE: If your Web browser is using a pop-up blocker, you must add "listings.ucdavis.edu" to the allowed sites to view the print preview. This is because the PDF is generated in a new Web browser window.<br/><br/>
			
			<ol>
				<li>Click on <em>Reports</em> in the Main Menu and then click on <em>Print Preview</em>.</li>
				<li>Select the listing department that you would like to preview.</li>
				<li>Select the PPS departments that you would like to include in your print preview. All of the individual listings in the selected listing department are associated with one of these PPS departments. You can choose which PPS departments you would like to include in your preview by checking the box(es) next to the desired PPS departments.</li>
			</ol>
			
			<br/><br/>
			
			<a name="multiple"></a>
			
			<br/>
			<h2>Download/Upload Spreadsheet</h2>
			<br/><br/>
			
			Please review the <a href="/listings/help/approver_guide.pdf">Approver Guide</a> for a comprehensive list of tasks you can and cannot complete using this feature.<br/><br/>
			
			<table cellpadding="4" cellspacing="1">
				<tr>
					<td valign="top" align="left" style="width:50%">
						<strong>First, download a spreadsheet that contains your department's individual listings.</strong>
						<ol>
							<li>To download a spreadsheet of the listings in a PPS department, click on <em>Tools</em> in the Main Menu, then click on <em>Download/Upload Spreadsheet</em> in the Tools sub-menu.</li>
							<li>On the <em>Download/Upload Spreadsheet</em> page, select the PPS department that you would like to download from the drop-down menu.  If you manage listings for more than one department, you will need to download and update one document for each department.</li>
							<li>Click <em>Download</em>.</li>
							<li>When the dialogue box appears, select where you want the file to be saved.<br/><br/></li>
						</ol>
						<em><strong>Note:</strong><br/>
							<ul>
								<li>The file you download is a comma separated values (CSV) file, which can be edited in most spreadsheet programs (e.g., Microsoft Excel).  If you change the file type to edit, you will need to convert it back to CSV before uploading the revised version.</li><br/>
								<li>Spreadsheets downloaded by unit approvers will only include listings information for individuals assigned to their unit.</li>
							</ul>
						</em>
						<br/>
						
						<strong>Next, update the individual listings in the spreadsheet.</strong>
						<ol>
							<li>Open the employee listings file you downloaded.</li>
							<li>Delete, add or edit as needed:<br/><br/></li>
						</ol>
						
						<ul>
							<li><strong>To DELETE</strong> an employee's secondary listing:<br/>Delete the entire row on the spreadsheet. <br/><br/></li>
							<li><strong>To ADD</strong> a secondary listing for an employee:<br/>Immediately below the primary listing, insert a new row on the spreadsheet.  Be sure to enter a "2" in the <strong>Listing Order</strong> column.<br/>Enter the relevant information.<br/>Leave <strong>ListingID</strong> blank (this will be generated automatically).<br/><br/></li>
							<em><strong>Note:</strong><br/>
								<li>For devices, use the format "X:111-222-3333" where X is the letter code for the device type. If you just put in the number, "V" will be used by default. The types are: </li>
								<br/>
								<ul>
									V = voice telephone<br/>
									C = cell phone<br/>
									F = fax number<br/>
									P = pager<br/>
									T = TDD<br/><br/>
								</ul>
							</em>
							<li><strong>To EDIT</strong> an existing listing:<br/>
								Change the values in the fields as needed.<br/><br/>
							</li>
						</ul>
						<strong>Next, be sure to save the edited file as .csv!</strong><br/><br/>
						<strong>Finally, upload the revised spreadsheet.</strong>
						<ol>
							<li>Click on <em>Tools</em> in the Main Menu, then click on <em>Download/Upload Spreadsheet</em> in the Tools sub-menu.</li>
							<li>Under STEP 3, select from the drop-down menu the department for which you are submitting changes.</li>
							<li>Select <em>"browse"</em> and find and select the file you updated on your computer.</li>
							<li>If you downloaded a partial listing or divided a spreadsheet into multiple spreadsheets, click the box next to <em>"This is a partial listing"</em>.</li>
							<li>Click <em>Upload</em>. </li>
						</ol>
					</td>
				</tr>
			</table>
			<br/><br/>
-->			
			<a name="publish"></a>
			
			<br/>
			<h2>Changing Publish Settings</h2>
			<br/><br/>
			
			Default Publish Settings<br/><br/>
			
			The hierarchy of publish settings is such that if the publish settings for an individual listing have not been modified, the default publish settings set by the approver at the departmental level take precedence. If the approver has not set defaults at the departmental level, the defaults set by the Campus Directory team at UC Davis and the UC Davis Health System at the institutional level take precedence.<br/><br/>
			
			To edit the default publish settings for an entire department:<br/><br/>
			
			<ol>
				<li>Click on <em>Tools</em>, then on <em>Default Publish Settings</em> in the Tools sub-menu. </li>
				<li>Select the department for which you'd like to change the default publish settings from the <em>Update Default Publish Settings for:</em> drop-down menu.</li>
				<li>Click <em>Submit</em>.</li>
				<li>Modify the publish settings listed as desired. To view the definitions of the various publishing options, click on the blue question mark next to <em>Publish Settings</em>.</li>
				<li>Click <em>Submit Updates</em> when you are finished.</li>
			</ol>
			<em>Note: If someone has elected not to publish any of their information, you should be sure to talk with them.  You should not change their publish settings unless you have talked with them and agreed that the settings should be changed.  In some cases, individuals may have filed a confidentiality agreement.  If they have, that agreement may apply to all identifying information, including name and phone number, and require that the information is not published.</em><br/><br/>
			
			To edit the publish settings for individual listings:<br/><br/>
			
			<em>Note: Publish settings defined using this method will apply only to this listing and will override the default publish settings.</em><br/><br/>
			
			<ol>
				<li>Click on <em>Tools</em> in the Main Menu, then click on <em>Individual Updates</em> in the Tools sub-menu.</li>
				<li>From the drop-down menu, select the PPS department that contains the individual listing(s) you would like to edit and click <em>Submit</em>.</li>
				<li>On the Listings for Department: <em>&lt;&lt;Department Name&gt;&gt;</em> page, find the listing for the individual whose publish settings you would like to change and click on <em>Update Listing</em>.</li>
				<li>Modify the publish settings listed on the right hand side of the entry as desired. Click on the blue question mark to get information about each setting.</li>
				<li>When you are finished adjusting the publish settings, click <em>Submit Request</em>.</li>
			</ol>
			<br/>
		</div>
</div>
				</div>

			</div>
		</div>
		<!--end .l-content-->

  <!--09-27-21 </div> -->
<!--End role=main-->
<p class="privacy">
	<strong>Privacy Notice:</strong> This campus directory is the property
	of <a href="https://www.ucdavis.edu"><font size="3" color="navy">University
			of California, Davis.</font> </a> To protect the privacy of individuals listed
	herein, in accordance with the State of California Information
	Practices Act, this directory may not be used, rented, distributed, or
	sold for commercial purposes.
</p>